import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import type { Control } from 'react-hook-form';

interface TextareaInputProps {
    field: {
        handle: string;
        label?: string;
        placeholder?: string;
        rows?: number;
        instructions?: string;
    };
    control: Control<Record<string, unknown>>;
}

export default function TextareaInput({ field, control }: TextareaInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem>
                    <FormLabel>{field.label}</FormLabel>
                    <FormControl>
                        <Textarea
                            {...formField}
                            value={formField.value as string}
                            placeholder={field.placeholder || ''}
                            rows={field.rows || 4}
                            className="bg-white"
                        />
                    </FormControl>
                    {field.instructions && (
                        <p className="text-muted-foreground text-sm">{field.instructions}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
